import React, { useEffect, useRef, useState } from 'react';
import {
  LinkFormContainer,
  LinkFormRow,
  LinkFormInputTitle,
  LinkFormAccept,
} from '../../atoms';
import { LinkInput } from '../../molecules';
import { Input } from '/ui/atoms';

// Old @flow
// типа LinkFormState использовался в componentWillUpdate
// кототрый не поддерживается в функциональных компонентах
// export type LinkFormState = {
//   text: string,
//   href: string
// }
// типа LinkFormProps использовался в componentDisUpdate
// кототрый не поддерживается в функциональных компонентах
// export type LinkFormProps = {
//   text: string,
//   href: string,
//   onSubmit: (LinkFormState) => void
// }

export const LinkForm = ({
  text: initialText = '',
  href: initialHref = '',
  childrens = [],
  onSubmit,
  inputRef,
}) => {
  const [text, setText] = useState(initialText);
  const [href, setHref] = useState(initialHref);

  // Хук для поддержки кейса "несколько узлов = берем текст первого"
  useEffect(() => {
    if (childrens && childrens.length > 1 && childrens[0]?.props?.node?.text) {
      setText(childrens[0].props.node.text);
    }
  }, []);

  // Универсальный ref для инпута текста (локальный, если не передан inputRef)
  const textInputRef = inputRef || useRef(null);

  // Обработка submit
  // event: SyntheticEvent<HTMLElement>
  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    onSubmit && onSubmit({ text, href });
  };

  // Универсальный обработчик для обоих инпутов
  // event: SyntheticEvent<HTMLElement>
  const handleChange = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const { name, value } = event.target;
    if (!name) {
      throw new TypeError('event.target.name is not found, check name attr');
    }
    if (name === 'text') {
      setText(value.trim());
    } else if (name === 'href') {
      setHref(value.trim());
    }
  };

  return (
    <LinkFormContainer
      onClick={e => e.stopPropagation()} // e: SyntheticEvent<HTMLElement>
      onSubmit={handleSubmit}
    >
      <LinkFormRow>
        <LinkFormInputTitle>Текст</LinkFormInputTitle>
        <Input
          type="text"
          name="text"
          value={text}
          onChange={handleChange}
        />
      </LinkFormRow>
      <LinkFormRow>
        <LinkFormInputTitle>Ссылка</LinkFormInputTitle>
        <LinkInput
          ref={textInputRef}
          href={href}
          handleChange={handleChange}
        />
      </LinkFormRow>
      <LinkFormRow>
        <LinkFormAccept>
          Сохранить
        </LinkFormAccept>
      </LinkFormRow>
    </LinkFormContainer>
  );
};

export default LinkForm;
